<script setup lang="ts">
import { Construction } from "@lucide/vue";
import { useI18n } from "vue-i18n";

import { Card, CardContent } from "@/shared/ui";

/**
 * Спільна заглушка розділу кабінету: заголовок розділу + empty-state
 * «Розділ у розробці». Widget-рівнева композиція (не DS-примітив): тонка
 * обгортка над `Card` для шести стаб-сторінок shell, без власної бізнес-логіки.
 *
 * DS-gap (для власника): з появою first-run онбордингу (IA D4 / idea-027)
 * знадобиться повноцінний `EmptyState`-примітив (icon+title+description+action).
 * Тоді цю заглушку варто промоутнути у `shared/ui` з реєстрацією у вітрині.
 */
defineProps<{
  /** Уже перекладений заголовок розділу. */
  title: string;
  /** data-testid кореня (для e2e/unit). */
  testid?: string;
}>();

const { t } = useI18n();
</script>

<template>
  <section
    :data-testid="testid"
    class="mx-auto max-w-3xl"
  >
    <h1 class="mb-6 text-2xl font-semibold tracking-tight">
      {{ title }}
    </h1>
    <Card>
      <CardContent
        class="flex flex-col items-center gap-3 py-14 text-center"
      >
        <Construction
          class="size-8 text-muted-foreground"
          aria-hidden="true"
        />
        <p class="font-medium text-foreground">
          {{ t("sections.inDevelopment") }}
        </p>
        <p class="max-w-sm text-sm text-muted-foreground">
          {{ t("sections.inDevelopmentHint") }}
        </p>
      </CardContent>
    </Card>
  </section>
</template>
